import { html } from "lit";
import { FinalFormController, zodValidator } from "../controllers/final-form.controller";
import { consume } from "@lit/context";
import { navigatorContext, NavigatorController } from "../controllers/navigator.controller";
import { Page } from "../components/component";
import { customElement } from "../element";
import { alertController } from "@ionic/core";
import type { ObservableEvaluationSection } from "../stores/evaluation.store";
import { reportsStore } from "../stores/reports.store";
import { UpdateEvaluationSectionSchema, type UpdateEvaluationSection } from "../repository/report/report";
import { localized, msg } from "@lit/localize";
import { ApiError } from "../error";

@customElement("modal-edit-evaluation-section")
@localized()
export class ModalEditEvaluationSection extends Page {
  @consume({ context: navigatorContext })
  private navigator!: NavigatorController;

  section!: ObservableEvaluationSection;

  #form = new FinalFormController<UpdateEvaluationSection>(this, {
    validate: zodValidator(UpdateEvaluationSectionSchema()),
    onSubmit: async (values) => {
      try {
        await reportsStore.updateEvaluationSectionLabel(this.section.id, values, this.section);
        this.navigator.close();
      } catch (error) {
        if (error instanceof ApiError) {
          const alert = await alertController.create({
            header: msg("Erro"),
            message: error.message,
            buttons: ["OK"],
          });
          await alert.present();
        }
      }
    },
  });

  render() {
    const { form, register, renderError } = this.#form;
    const formState = form.getState();

    return html`
      <div class="inner-content">
        <ion-header>
          <ion-toolbar style="--border-color: #eaeaea">
            <ion-buttons slot="start">
              <ion-button @click=${() => this.navigator.close()} class="font-semibold">
                <span class="mt-[3px] -ml-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </span>
                ${msg("fechar")}</ion-button
              >
            </ion-buttons>
            <ion-title class="font-display text-lg">${msg("Nome da Secção")}</ion-title>
          </ion-toolbar>
        </ion-header>
        <form
          id="form-evaluation-section-edit"
          class="space-y-4 mt-4"
          @submit=${(e: Event) => {
            e.preventDefault();
            form.submit();
          }}>
          <ion-list lines="none">
            <div>
              <span class="font-semibold font-display">${msg("Nome")}</span>
              <ion-item class="mt-1">
                <ion-input
                  autocapitalize="on"
                  type="text"
                  placeholder=${msg("Secção")}
                  enterkeyhint="send"
                  ${register("label", { initialValue: this.section.label })}>
                </ion-input>
              </ion-item>
              ${renderError("label")}
            </div>
          </ion-list>

          <ion-button
            form="form-evaluation-section-edit"
            type="submit"
            color="primary"
            expand="block"
            shape="round"
            class="font-semibold"
            ?disabled=${formState.submitting}
            >${msg("Guardar Alterações")}</ion-button
          >
        </form>
      </div>
    `;
  }
}
